import React from 'react';
import MainContent from '../MainContent/MainContent';


const Home = () => {
    

    return (
        
            <MainContent></MainContent>
       
    );
};

export default Home;